import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { CustomerPortal } from '../models/customer-portal';
import { IFileStoreItem } from '../../../documents/interfaces/IFileStoreItem';
import { IFileInfo } from '../../../directives/file-drop/interfaces/IFileInfo';
import { Observable } from 'rxjs';
import { IDownloadResult, IExportOperationResult } from '../../../base/interfaces/IDownloadResult';

@Injectable({
  providedIn: 'root'
})
export class CustomerPortalService extends BaseService<CustomerPortal> {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string            
  ) { 
    super(http,rootUrl,'Plasard/CustomerPortal');
  }
  SendEmail(model: CustomerPortal, file:IFileInfo): Observable<any> {
    const request:SendEmailRequest = <SendEmailRequest>{
      payload: model,
      parameters: file
    };
    return this.http.post<SendEmailRequest>(`${this.rootUrl}/${this.endpoint}/operation/${model.id}/send-email`, request);
  }  
  GeneratePdf(model: CustomerPortal): Observable<IExportOperationResult> {
    return this.http.post<IExportOperationResult>(`${this.rootUrl}/${this.endpoint}/export/${model.id}/generate-pdf`, model);
  }    
}

export class SendEmailRequest {
  payload: CustomerPortal;
  parameters:IFileStoreItem;
}